import React from 'react';
import http from '../modules/api';

export class RpAutoAlgorithmTableBySalePrice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_page_id: '-1',
      tableData: [
        // { name: '카테고리 기획전 자동화하기', page: '', id: 'category' }
      ]
    };
  }

  componentDidMount() {
    this.loadAutoDisplaySelePercentSettingList();
  }

  loadAutoDisplaySelePercentSettingList () {
    http.get("/rest/shop/rp/autoDisplayPriceSetting/list"
      + "?filter_page_id=" + this.state.filter_page_id
      + "&price_cd=" + (this.props.price_cd || '')
    )
    .then(res => {
      this.setState({ tableData: res.data.list });
    }).catch(error => {
      console.log(error);
    })
  }

  onClickFilter = (filter_id) => {
    this.setState({ filter_page_id: filter_id }, () => {
      this.loadAutoDisplaySelePercentSettingList ();
    });
  };

  onClickRegister = (id, page, category_display_group, targetCloneObj) => {
    this.props.onClickRegistButton?.(id, page, category_display_group, targetCloneObj);
  };

  render() {
    const { tableData, filter_page_id } = this.state;

    return (
      // <div id='common-page-wrapper' className="style_guide_v2">
      <div id="list_wrap" className="list_wrap_background" style={{overflowY:"auto"}}>
        <div className="algorithm_list_wrap RpAutoAlgorithmTable">
          <h3>마지막으로 분석정보로 자동진열 위치별 알고리즘설정을 해드립니다. 자동화하고 싶은 진열코너를 선택해주세요</h3>

          {/* 탭 버튼 */}
          <div className='flexBox algorithm_option_area' style={{justifyContent: "space-between"}}>
            <div className="algorithm_filter_area">
              <div className={filter_page_id === '-1' ? 'active' : ''} onClick={() => this.onClickFilter('-1')}>전체</div>
              <div className={filter_page_id === 'robomd_cafe24_main_page' ? 'active' : ''} onClick={() => this.onClickFilter('robomd_cafe24_main_page')}>메인</div>
              <div className={filter_page_id === 'robomd_cafe24_category_page' ? 'active' : ''} onClick={() => this.onClickFilter('robomd_cafe24_category_page')}>카테고리</div>
            </div>
          </div>

          {/* 테이블 모양 */}
          <div className="algorithm_table_area algorithm_table_area_v2 algorithm_table_area_keyword" style={{display: "block"}}>
            <table>
              <thead>
                <tr>
                  <td className="list_td">가격</td>
                  <td className="list_td">진열 알고리즘 설명</td>
                  <td className="list_td">추천 페이지</td>
                  <td className="list_td">등록</td>
                </tr>
              </thead>
              <tbody>
                {tableData.map((item, idx) => (
                  <tr key={item.template_id} onClick={() => this.onClickRegister(item.template_id, item.iframe_page_id, item.cafe24_category_display_group, item)}>
                    <td>{this.props.price_value}</td>
                    <td>{item.template_name}</td>
                    <td>
                      {
                        item.iframe_page_id != "robomd_cafe24_category_page" 
                        ? item.iframe_page_simple_name 
                        : item.iframe_page_simple_name
                            +   (item.cafe24_category_display_group == "1" 
                                ? " (일반)"
                                : item.cafe24_category_display_group == "2" 
                                    ? " (추천)"
                                    : item.cafe24_category_display_group == "3" 
                                        ? " (신상)" 
                                        : "")
                      }
                    </td>
                    <td>
                      <button
                        className="selected_list_btn btn_algorithm_regist hover_mint"
                        onClick={() => this.onClickRegister(item.template_id, item.iframe_page_id, item.cafe24_category_display_group, item)}
                      >
                        등록하기
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      // </div>
    );
  }
}